import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@material-ui/core';

/**
 * Competition Design System — the ONE confirmation dialog for competition
 * workflow transitions (draw reset / approve / reopen, score-round complete
 * / reopen, …): title + message lines + Cancel / Confirm. The caller owns
 * the wording, the consequence and the testId namespace.
 */
const ConfirmDialog = props => {
    const { open, title, messages, confirmLabel, onCancel, onConfirm, testId } = props;
    const [t] = useTranslation();

    return (
        <Dialog onClose={onCancel} maxWidth='sm' open={open} data-testid={testId}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>
                {messages.map((message, index) => (
                    <Typography key={index} color='textSecondary' variant='body1' gutterBottom>
                        {message}
                    </Typography>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} data-testid={`${testId}-cancel`}>
                    {t('buttons.cancel')}
                </Button>
                <Button
                    color='primary'
                    variant='contained'
                    onClick={onConfirm}
                    data-testid={`${testId}-confirm`}
                >
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ConfirmDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    messages: PropTypes.array.isRequired,
    confirmLabel: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    testId: PropTypes.string.isRequired,
};

export default ConfirmDialog;
